





































































































































import { rulesMixin } from '@/shared';
import {
  AdminsCards,
  OpportunityRoleCards,
} from '@/components/rules';
import { GeekItemWithJobTitle } from '@/models';
import { Actions } from '@/store';
import mixins from 'vue-typed-mixins';

export default mixins(rulesMixin).extend({
  name: 'BasicRulesView',
  components: {
    AdminsCards,
    OpportunityRoleCards,
  },
  computed: {
    adminsWithSuperAdmins(): GeekItemWithJobTitle[] {
      return [...this.superAdmins, ...this.admins];
    },
  },
  methods: {
    async fetchData() {
      await Promise.all([
        this.$store.dispatch(Actions.geek.fetchAdmins),
        this.$store.dispatch(Actions.geek.fetchSuperAdmins),
      ]);

      if (this.$isAccessible(this.$permissions.opportunity)) {
        await Promise.all([
          this.$store.dispatch(Actions.opportunities.fetchIssuers),
          this.$store.dispatch(Actions.opportunities.fetchAdmins),
        ]);
      }
    },
  },
});
